import { ReportGroupings } from '@appTypes/enums';
import { ProgramId } from '@shared/constants';

import { reportCodes, moduleName as rootModuleName } from '../constants';

export { reportCodes };

export const moduleName = 'basicReports';

export const moduleNamespace = `${rootModuleName}/${moduleName}`;

const activitiesReports = [
  reportCodes.ACTIVITY_LOG,
  reportCodes.ACTIVITY_LOG_BY_MEMBER_ID,
  reportCodes.AUDIT_LOG,
  reportCodes.PAYMENT_LOG,
  reportCodes.EAGLE_SCOUT_RANK_APPLICATION,
  reportCodes.SCOUTS_BSA_INDIVIDUAL_ADVANCEMENT,
  reportCodes.YPT_AGING_REPORT,
  reportCodes.TRAINED_LEADER_STATUS,
  reportCodes.ACTIVITIES_SUMMARY,
  reportCodes.CUB_SCOUT_HISTORY,
  reportCodes.TENTMATE,
  reportCodes.UNIT_ROSTER_LITE,
  reportCodes.REPORT_BUILDER_OUTPUT,
  reportCodes.ROSTER_BUILDER_ADULTS,
  reportCodes.ROSTER_BUILDER_YOUTHS,
  reportCodes.CUB_HISTORY_BY_MEMBER_ID,
];

export const validReports = Object.freeze({
  [ProgramId.CUB_SCOUT]: [
    reportCodes.PACK_RECOGNITION,
    reportCodes.ELIGIBILITY_REPORT,
    reportCodes.ATTENDANCE,
    ...activitiesReports,
  ],
  [ProgramId.BOY_SCOUT]: [
    reportCodes.INDIVIDUAL_SCOUTS_BSA,
    reportCodes.TROOP_RECOGNITION,
    reportCodes.ELIGIBILITY_REPORT,
    reportCodes.SCOUTS_BSA_HISTORY,
    reportCodes.ATTENDANCE,
    reportCodes.IN_PROGRESS_MB,
    reportCodes.SCOUT_HISTORY_BY_MEMBER_ID,
    reportCodes.EAGLE_SCOUT_BY_MEMBER_ID,
    ...activitiesReports,
  ],
  [ProgramId.VENTURING]: [
    reportCodes.VENTURING_HISTORY,
    reportCodes.ELIGIBILITY_REPORT,
    reportCodes.ATTENDANCE,
    reportCodes.IN_PROGRESS_MB,
    reportCodes.SUMMIT_APPLICATION_BY_MEMBER_ID,
    ...activitiesReports,
  ],
  [ProgramId.SEA_SCOUT]: [
    reportCodes.SEA_SCOUT_HISTORY,
    reportCodes.ELIGIBILITY_REPORT,
    reportCodes.ATTENDANCE,
    reportCodes.IN_PROGRESS_MB,
    reportCodes.QUATERMASTER_AWARD_APPLICATION_BY_MEMBER_ID,
    ...activitiesReports,
  ],
});

export const reportsV2 = [
  reportCodes.AUDIT_LOG,
  reportCodes.INDIVIDUAL_SCOUTS_BSA,
  reportCodes.CUB_SCOUT_HISTORY,
  reportCodes.SEA_SCOUT_HISTORY,
  reportCodes.ACTIVITY_LOG,
  reportCodes.VENTURING_HISTORY,
  reportCodes.SCOUTS_BSA_HISTORY,
];

export const individualReports = [
  reportCodes.INDIVIDUAL_SCOUTS_BSA,
  reportCodes.CUB_SCOUT_HISTORY,
  reportCodes.SEA_SCOUT_HISTORY,
  reportCodes.VENTURING_HISTORY,
  reportCodes.SCOUTS_BSA_HISTORY,
];

export const groupLevels: Record<string, number> = {
  [ReportGroupings.Quick_Export]: 1,
  [ReportGroupings.Not_Grouped]: 2,
};

export const specialLabelGroups: Record<string, string> = {
  [ReportGroupings.Quick_Export]: 'export',
};

export const byMemberIdReports = [
  reportCodes.CUB_HISTORY_BY_MEMBER_ID,
  reportCodes.SCOUT_HISTORY_BY_MEMBER_ID,
  reportCodes.ACTIVITY_LOG_BY_MEMBER_ID,
  reportCodes.EAGLE_SCOUT_BY_MEMBER_ID,
  reportCodes.SUMMIT_APPLICATION_BY_MEMBER_ID,
  reportCodes.QUATERMASTER_AWARD_APPLICATION_BY_MEMBER_ID,
];
